import { render, staticRenderFns } from "./ProfileMessagingProfile.vue?vue&type=template&id=65b13d35&"
import script from "./ProfileMessagingProfile.vue?vue&type=script&lang=js&"
export * from "./ProfileMessagingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports